<template>
    <div>
        <Button
            :variant="variant"
            @click="toggleTransform"
        >
            <slot name="buttonPrefix" />
            {{ buttonText }}
            <slot name="buttonSuffix" />
        </Button>

        <BCollapse
            class="mt-3"
            :visible="expanded"
        >
            <!-- Content to be displayed when in an expanded state-->
            <slot />
        </BCollapse>

        <Button
            v-if="expanded"
            class="mt-3"
            variant="primary"
            :disabled="disableActionButton"
            @click="performAction"
        >
            <slot name="expandedButtonPrefix" />
            {{ expandedButtonText }}
            <slot name="expandedButtonSuffix" />
        </Button>
    </div>
</template>

<script>
    import Button from './Button.vue';

    /**
     * @group Buttons
     * A component to utilize a Kit Car button transform.
     */
    export default {
        name: 'KCButtonTransform',
        components: {
            Button
        },
        model: {
            prop: 'expanded',
            event: 'toggle-collapse',
        },
        props: {
            /**
             * When supplied or set to `true`, disables the action button's functionality and
             * places it in a disabled state.
             */
            disableActionButton: {
                type: Boolean,
                default: false
            },
            /**
             * Sets the active state of the Transform Button collapse; supplies the value for `v-model`.
             */
            expanded: {
                type: Boolean,
                required: true
            },
            /**
             * Sets the text for the primary button that is displayed when the component is in an expanded state.
             */
            expandedButtonText: {
                type: String,
                default: 'Submit'
            },
            /**
             * Sets the text for the primary button that is displayed when the component is in an unexpanded state.
             */
            initialButtonText: {
                type: String,
                required: true
            }
        },
        computed: {
            buttonText() {
                return this.expanded ? 'Cancel' : this.initialButtonText;
            },
            variant() {
                return this.expanded ? 'secondary' : 'primary';
            }
        },
        methods: {
            performAction() {
                /**
                 * Emitted when the expanded primary button is clicked; allows for an action to occur as a result
                 * of the expansion. The `expanded` prop should be toggled to false on the usage following a successful
                 * action.
                 */
                this.$emit('perform-action');
            },
            toggleTransform() {
                /**
                 * Is used when binding via `v-model` for updating the `expanded` prop.
                 */
                this.$emit('toggle-collapse', !this.expanded);
            },
        },
    };
</script>

<style
    scoped
    lang="sass"
>
    textarea
        min-width: 550px
</style>
